import { Controller } from "@hotwired/stimulus"

export default class ListFilterController extends Controller {
  static targets = ["input", "item"]

  filter() {
    const query = this.inputTarget.value.toLowerCase()
    this.itemTargets.forEach((item) => this.#apply(item, query))
  }

  inputTargetConnected() {
    this.filter()
  }

  itemTargetConnected(item) {
    this.#apply(item, this.inputTarget.value.toLowerCase())
  }

  #apply(item, query) {
    const itemMatchesQuery = item.dataset.filterText
      .toLowerCase()
      .includes(query)

    item.style.display = itemMatchesQuery ? "" : "none"
  }
}
